// extracted by mini-css-extract-plugin
module.exports = {"rightFooter":"rightFooter-module--right-footer--1o2c6","show":"rightFooter-module--show--25sLf","text":"rightFooter-module--text--MuXsU","link":"rightFooter-module--link--3ORkL"};